<form [formGroup]="formGroup">

  <sc-sub-title>
    <sc-dictionary-label dictionaryKey="tmc.visit.masterdata.title"></sc-dictionary-label>
  </sc-sub-title>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-flex>
    <sc-string-field grow formControlName="firstName" [required]="true"
      labelDictionaryKey="tmc.visit.masterdata.firstname">
    </sc-string-field>
    <sc-content-spacer></sc-content-spacer>
    <sc-string-field grow formControlName="name" [required]="true" labelDictionaryKey="tmc.visit.masterdata.name">
    </sc-string-field>
    <sc-content-spacer></sc-content-spacer>
    <sc-string-field grow formControlName="company" labelDictionaryKey="tmc.visit.masterdata.company">
    </sc-string-field>
  </sc-flex>
  <sc-content-spacer vertical></sc-content-spacer>
  <sc-flex>
    <sc-string-field [grow]="false" formControlName="personalId" [required]="idNumberRequired"
      labelDictionaryKey="tmc.visit.masterdata.personalId">
    </sc-string-field>
    <sc-content-spacer></sc-content-spacer>
    <mat-form-field appearance="fill" style="width: 100%;">
      <mat-label>
        <sc-dictionary-label dictionaryKey="tmc.visit.masterdata.type"></sc-dictionary-label>
      </mat-label>
      <mat-select [required]="true" formControlName="visitorType">
        <mat-option *ngFor="let type of types" [value]="type">
          <sc-dictionary-label [dictionaryKey]="type.dictionaryKey"></sc-dictionary-label>
        </mat-option>
      </mat-select>
    </mat-form-field>
    <sc-content-spacer></sc-content-spacer>
    <sc-checkbox-field formControlName="confirmed" labelDictionaryKey="tmc.visit.masterdata.confirmed"
      class="no-wrap"></sc-checkbox-field>
  </sc-flex>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-flex>

    <ng-container *ngIf="upfrontRegistration">
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-date-time-field-legacy [required]="true" formControlName="plannedArrival"
        [label]="'planned arrival' | translate:['tmc.visit.masterdata.plannedArrival',translationService.language]">
      </sc-date-time-field-legacy>
    </ng-container>

    <sc-content-spacer></sc-content-spacer>

    <sc-dictionary-label dictionaryKey="tmc.visit.masterdata.endByRole"></sc-dictionary-label>
    <sc-content-spacer></sc-content-spacer>
    {{formatEndByRoleDate(visit.endByRole)}}

    <sc-content-spacer grow></sc-content-spacer>

    <sc-checkbox-field formControlName="defineEndDate" labelDictionaryKey="tmc.visit.masterdata.defineEndDate">
    </sc-checkbox-field>
    <sc-content-spacer></sc-content-spacer>
    <sc-date-field-legacy formControlName="definedEndDate" labelDictionaryKey="tmc.visit.masterdata.definedEndDate"
      [required]="visit.defineVisitEnd">
    </sc-date-field-legacy>

  </sc-flex>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-flex>
    <sc-checkbox-field formControlName="sendVisitorMail" labelDictionaryKey="tmc.visit.masterdata.sendMail">
    </sc-checkbox-field>
    <sc-content-spacer></sc-content-spacer>
    <sc-string-field grow formControlName="visitorMail" labelDictionaryKey="tmc.visit.masterdata.mail">
    </sc-string-field>
  </sc-flex>

  <sc-content-spacer vertical double></sc-content-spacer>

  <sc-sub-title>
    <sc-dictionary-label dictionaryKey="tmc.visit.masterdata.title-invitation-parameters"></sc-dictionary-label>
  </sc-sub-title>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-checkbox-field formControlName="inviteAdditionalVisitorsAllowed"
    labelDictionaryKey="tmc.visit.masterdata.inviteAdditionalVisitorsAllowed">
  </sc-checkbox-field>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-checkbox-field formControlName="invitationRequiresConfirmation"
    labelDictionaryKey="tmc.visit.masterdata.invitationRequiresConfirmation"></sc-checkbox-field>
  <sc-content-spacer vertical></sc-content-spacer>
  <sc-flex>
    <sc-content-spacer double></sc-content-spacer>
    <sc-checkbox-field formControlName="invitationConfirmationOnAccessOnly"
      labelDictionaryKey="tmc.visit.masterdata.invitationConfirmationOnAccessOnly"></sc-checkbox-field>
  </sc-flex>
  <sc-content-spacer vertical></sc-content-spacer>
  <sc-checkbox-field formControlName="assignPrivilegesOnInvitation"
    labelDictionaryKey="tmc.visit.masterdata.assignPrivilegesOnInvitation"></sc-checkbox-field>

  <sc-content-spacer vertical double></sc-content-spacer>

  <sc-sub-title>
    <sc-dictionary-label dictionaryKey="tmc.visit.masterdata.title-vehicle-usage"></sc-dictionary-label>
  </sc-sub-title>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-flex>
    <sc-checkbox-field formControlName="withCar" labelDictionaryKey="tmc.visit.masterdata.withCar">
    </sc-checkbox-field>
    <sc-content-spacer></sc-content-spacer>
    <sc-string-field grow formControlName="numberplate" labelDictionaryKey="tmc.visit.masterdata.numberplate">
    </sc-string-field>
  </sc-flex>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-flex>
    <sc-checkbox-field formControlName="needsAreaAccessByCar"
      labelDictionaryKey="tmc.visit.masterdata.needsAreaAccessByCar">
    </sc-checkbox-field>
    <sc-content-spacer></sc-content-spacer>
    <sc-checkbox-field formControlName="grandAreaAccessByCar"
      labelDictionaryKey="tmc.visit.masterdata.grandAreaAccessByCar">
    </sc-checkbox-field>
    <sc-content-spacer></sc-content-spacer>
    <sc-checkbox-field formControlName="grandAreaAccessOnFoot"
      labelDictionaryKey="tmc.visit.masterdata.grandAreaAccessOnFoot">
    </sc-checkbox-field>
  </sc-flex>


</form>
